import React from 'react';
import Button from '@ui-library/button';
import {
  Navigation,
  Description,
  DescriptionProps,
  NavigationProps,
} from '@components/common/header';

import classes from '../source-details.module.scss';
import { PlayCircleOutlined } from '@ant-design/icons';

interface OwnProps extends DescriptionProps, NavigationProps {
  onClickLiveEvents?: () => void;
  disabledLiveEventMsg?: string;
}

type Props = OwnProps;

const SourceDetailsHeader = ({
  backButton,
  name,
  defName,
  handleNameSave,
  showCopyIcon,
  validateInput,
  onClickLiveEvents,
  handleCopy,
  disabledLiveEventMsg,
  displayName,
  isDestination,
  isAdmin,
}: Props) => (
  <>
    <Navigation name={name} backButton={backButton} />
    <div className={classes.header_container}>
      <Description
        name={name}
        defName={defName}
        handleNameSave={handleNameSave}
        showCopyIcon={showCopyIcon}
        validateInput={validateInput}
        handleCopy={handleCopy}
        displayName={displayName}
        isDestination={isDestination}
        isAdmin={isAdmin}
      />
      {disabledLiveEventMsg ? (
        <Button secondary disabled tooltip={disabledLiveEventMsg} tooltipPlacement="left">
          <PlayCircleOutlined />
          <span className="m-l-sm">Live events</span>
        </Button>
      ) : (
        <Button secondary onClick={onClickLiveEvents}>
          <PlayCircleOutlined />
          <span className="m-l-sm">Live events</span>
        </Button>
      )}
    </div>
  </>
);

export default SourceDetailsHeader;
